export const environment = {
  authConfig: {
    loginUrl: 'https://reseau-rec.prodemial.fr/cas/oauth2.0/authorize',
    tokenUrl: 'https://reseau-rec.prodemial.fr/cas/oauth2.0/token',
    logoutUrl: 'https://reseau-rec.prodemial.fr/cas/logout?service=' + encodeURI(window.location.origin),
    clientId: 'c3nxwh3agx.stellium',
    authGroup: 'APP_MYAPP',
    consultantGroups: ['CN=GOF_CONSULTANT'],
    backOfficeGroups: [
      'CN=APP_PLACEMENT_BACKOFFICE_COURTAGE_RECETTE',
      'CN=APP_PLACEMENT_BACKOFFICE_INVEST_RECETTE',
      'CN=APP_PLACEMENT_BACKOFFICE_RECETTE',
    ],
    backOfficeAdminGroups: ['CN=APP_PLACEMENT_BACKOFFICE_ADMIN_RECETTE'],
  },
  backEndUrl: 'https://ficheconseilgateway-api.int.finzzle-groupe.com/graphql',
  appInsightsKey: 'da36b89c-c84f-4f4f-97bf-c99900c4dcfd',
};
